var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"my-6 font-weight-regular headline"},[_c('v-icon',{staticClass:"mr-3",domProps:{"textContent":_vm._s(_vm.icon)}}),_vm._v(" "+_vm._s(_vm.value)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }